<template>
  <div id="dashboard-page">
    <!-- filter component  -->
    <b-card no-body>
      <!-- header component -->
      <b-card-header>
        <div>
          <!-- title -->
          <b-card-title class="d-flex align-items-center">
            <i class="bi bi-columns-gap"></i>
            <span style="margin-left: 5px"> Dashboard </span>
          </b-card-title>
        </div>
        <div
          class="d-flex flex-wrap gap-5px justify-content-end align-items-center"
        >
          <checkURL />
          <!-- date picker -->
          <dateRangePicker
            :from_date="filter_data.from_date"
            :to_date="filter_data.to_date"
            @update-value="dateFilterChanged"
          />
        </div>
      </b-card-header>
    </b-card>
    <!-- scraper status statistics -->
    <b-card>
      <!-- title -->
      <b-card-title class="mb-1 d-flex align-items-center">
        <span style="margin-left: 5px">
          Statistik
        </span>
      </b-card-title>
      <!-- loader component -->
      <loader v-if="loading_stats" />
      <!-- stats component -->
      <div v-else-if="!loading_stats" class="row">
        <!-- error status -->
        <div class="col-md-4 py-2">
          <div class="media">
            <div class="media-aside mr-2 align-self-start">
              <span
                class="b-avatar badge-light-danger rounded-circle"
                style="width: 48px; height: 48px"
              >
                <span class="b-avatar-custom">
                  <i class="bi bi-x-circle fs-18"></i>
                </span>
              </span>
            </div>
            <div class="media-body my-auto">
              <h4 class="font-weight-bolder mb-0">{{ stats.error }}</h4>
              <p class="card-text font-small-3 mb-0">Error Status</p>
            </div>
          </div>
        </div>
        <!-- missing class status -->
        <div class="col-md-4 py-2">
          <div class="media">
            <div class="media-aside mr-2 align-self-start">
              <span
                class="b-avatar badge-light-warning rounded-circle"
                style="width: 48px; height: 48px"
              >
                <span class="b-avatar-custom">
                  <i class="bi bi-exclamation-circle fs-18"></i>
                </span>
              </span>
            </div>
            <div class="media-body my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ stats.missing_class }}
              </h4>
              <p class="card-text font-small-3 mb-0">Missing Class Status</p>
            </div>
          </div>
        </div>
        <!-- fixing error status -->
        <div class="col-md-4 py-2">
          <div class="media">
            <div class="media-aside mr-2 align-self-start">
              <span
                class="b-avatar badge-light-primary rounded-circle"
                style="width: 48px; height: 48px"
              >
                <span class="b-avatar-custom">
                  <i class="bi bi-tools fs-18"></i>
                </span>
              </span>
            </div>
            <div class="media-body my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ stats.fixing_error }}
              </h4>
              <p class="card-text font-small-3 mb-0">Preventive Fix</p>
            </div>
          </div>
        </div>
        <!-- redirected status -->
        <div class="col-md-4 py-2">
          <div class="media">
            <div class="media-aside mr-2 align-self-start">
              <span
                class="b-avatar badge-light-info rounded-circle"
                style="width: 48px; height: 48px"
              >
                <span class="b-avatar-custom">
                  <i class="bi bi-repeat fs-18"></i>
                </span>
              </span>
            </div>
            <div class="media-body my-auto">
              <h4 class="font-weight-bolder mb-0">{{ stats.redirected }}</h4>
              <p class="card-text font-small-3 mb-0">Redirected Status</p>
            </div>
          </div>
        </div>
        <!-- unavailable status -->
        <div class="col-md-4 py-2">
          <div class="media">
            <div class="media-aside mr-2 align-self-start">
              <span
                class="b-avatar badge-light-secondary rounded-circle"
                style="width: 48px; height: 48px"
              >
                <span class="b-avatar-custom">
                  <i class="bi bi-slash-circle fs-18"></i>
                </span>
              </span>
            </div>
            <div class="media-body my-auto">
              <h4 class="font-weight-bolder mb-0">{{ stats.unavailable }}</h4>
              <p class="card-text font-small-3 mb-0">Unavailable Status</p>
            </div>
          </div>
        </div>
        <!-- fixed status -->
        <div class="col-md-4 py-2">
          <div class="media">
            <div class="media-aside mr-2 align-self-start">
              <span
                class="b-avatar badge-light-success rounded-circle"
                style="width: 48px; height: 48px"
              >
                <span class="b-avatar-custom">
                  <i class="bi bi-check-circle fs-18"></i>
                </span>
              </span>
            </div>
            <div class="media-body my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ stats.fixed }}
              </h4>
              <p class="card-text font-small-3 mb-0">Fixed</p>
            </div>
          </div>
        </div>
      </div>
    </b-card>
    <!-- scraper graph -->
    <b-card>
      <!-- title -->
      <b-card-title class="mb-1 d-flex align-items-center">
        <span style="margin-left: 5px"> Grafik Log Scraper per Status </span>
      </b-card-title>
      <!-- loader component -->
      <loader v-if="loading_chart" />
      <!-- linechart component -->
      <b-card-body v-else-if="!loading_chart">
        <lineChart :data="chart_data" />
      </b-card-body>
    </b-card>
    <!-- scraper progress graph -->
    <b-card>
      <!-- title -->
      <b-card-title class="mb-1 d-flex align-items-center">
        <span style="margin-left: 5px"> Grafik Total Data Scraper per Hari </span>
      </b-card-title>
      <!-- loader component -->
      <loader v-if="loading_chart_scraper" />
      <!-- linechart component -->
      <b-card-body v-else-if="!loading_chart_scraper">
        <lineChart :data="chart_data_scraper" />
      </b-card-body>
    </b-card>
    <!-- story point graph -->
    <b-card>
      <!-- title -->
      <b-card-title class="mb-1 d-flex align-items-center">
        <span style="margin-left: 5px"> Grafik Story Point per User </span>
      </b-card-title>
      <!-- loader component -->
      <loader v-if="loading_chart_sp" />
      <!-- linechart component -->
      <b-card-body v-else-if="!loading_chart_sp">
        <lineChart :data="chart_data_sp" />
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import moment from "moment";
import useJwt from "@/auth/jwt/useJwt";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardSubTitle,
  BCardBody,
} from "bootstrap-vue";
import lineChart from "@/views/components/lineChart.vue";
import loader from "@/views/components/loader.vue";
import dateRangePicker from "@/views/components/dateRangePicker.vue";
import checkURL from "@/views/components/checkURL.vue";
import axios from "axios";

export default {
  name: "Dashboard",
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    BCardBody,
    lineChart,
    dateRangePicker,
    checkURL,
    loader,
  },
  data() {
    return {
      loading_stats: true,
      loading_chart: true,
      loading_chart_scraper: true,
      filter_data: {
        from_date:
          this.$route?.query?.from_date ||
          moment(new Date())
            .subtract(7, "days")
            .format("YYYY-MM-DD 00:00:00"),
        to_date:
          this.$route?.query?.to_date ||
          moment(new Date()).format("YYYY-MM-DD 23:59:59"),
      },
      stats: {
        error: 0,
        unavailable: 0,
        redirected: 0,
        missing_class: 0,
        fixed: 0,
        fixing_error: 0,
      },
      chart_data: {
        colors: [
          "#ea5455",
          "#ff9f43",
          "#82868b",
          "#00cfe8",
          "#28c76f",
          "#7367f0",
        ],
        categories: [],
        series: [
          {
            name: "Error",
            data: [],
          },
          {
            name: "Missing Class",
            data: [],
          },
          {
            name: "Unavailable",
            data: [],
          },
          {
            name: "Redirected",
            data: [],
          },
          {
            name: "Fixed",
            data: [],
          },
          {
            name: "Preventive Fix",
            data: [],
          },
        ],
        markers: {
          size: [5, 5, 5, 5, 5, 5],
          hover: {
            size: 5,
          },
        },
      },
      chart_data_scraper: {
        colors: [
          "#00cfe8",
          "transparent",
          "transparent",
          "transparent",
          "transparent",
          "transparent",
        ],
        categories: [],
        series: [
          {
            name: "",
            data: [],
          },
          {
            name: "",
            data: [],
          },
          {
            name: "",
            data: [],
          },
          {
            name: "",
            data: [],
          },
          {
            name: "",
            data: [],
          },
          {
            name: "",
            data: [],
          },
        ],
        markers: {
          size: [5, 0, 0, 0, 0, 0],
          hover: {
            size: 5,
          },
        },
        legend: {
          formatter: function(seriesName) {
            if (seriesName === "Total") {
              return seriesName
            }
            else {
              return null
            }
        }},
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: function (value, { seriesIndex, dataPointIndex, w }) {
              const seriesItem = w.config.series[seriesIndex];
              const portalName = seriesItem.portal_name?.[dataPointIndex] || "";
              return value + (portalName ? ` (${portalName})` : "");
            },
            title: {
              formatter: function (seriesName) {
                return seriesName;
              }
            }
          },
          x: { show: false },
        }

      },
      loading_chart_sp: false,
      cancel_chart_sp_token: null,
      chart_data_sp: {
        colors: [
          "#00cfe8",
          "#ff9f43",
          "#ea5455",
          "#28c76f",
          "#7367f0",
          "#82868b",
        ],
        categories: [],
        series: [],
        markers: {
          size: [5, 5, 5, 5, 5, 5],
          hover: {
            size: 5,
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: function (value, { seriesIndex, dataPointIndex, w }) {
              return value;
            },
            title: {
              formatter: function (seriesName) {
                return seriesName;
              }
            }
          },
          x: { show: false },
        }
      },
      cancel_stats_token: null,
      cancel_chart_token: null,
      cancel_chart_scraper_token: null,
    };
  },
  created() {
    this.getData();
  },
  beforeDestroy() {
    if (this.cancel_chart_token) {
      this.cancel_chart_token.cancel("ERR_CANCELED");
    }
    if (this.cancel_chart_scraper_token) {
      this.cancel_chart_scraper_token.cancel("ERR_CANCELED");
    }
    if (this.cancel_stats_token) {
      this.cancel_stats_token.cancel("ERR_CANCELED");
    }
    if (this.cancel_chart_sp_token) {
      this.cancel_chart_sp_token.cancel("ERR_CANCELED");
    }
  },
  methods: {
    dateFilterChanged(data) {
      this.filter_data.from_date = data.from_date;
      this.filter_data.to_date = data.to_date;
      this.getData();
    },
    getData() {
      this.getStats();
      this.getChart();
      this.getChartScraper();
      this.getChartStoryPoint();
    },
    getChart() {
      this.loading_chart = true;
      if (this.cancel_chart_token) {
        this.cancel_chart_token.cancel("ERR_CANCELED");
      }
      this.cancel_chart_token = axios.CancelToken.source();

      let params = {
        from_date: this.filter_data.from_date,
        to_date: this.filter_data.to_date,
      };
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api = process.env.VUE_APP_API_URL + "dashboard/charts-log?" + query;
      useJwt.axiosIns
        .get(api, { cancelToken: this.cancel_chart_token.token })
        .then((res) => {
          this.cancel_chart_token.value = null;
          if (res.status == 200) {
            this.chart_data.categories = res.data.categories;
            for (let i = 0; i < this.chart_data.series.length; i++) {
              this.chart_data.series[i].data = res.data.series[i].value;
            }
          } else {
            this.chart_data = {
              categories: [],
              series: [],
            };
          }
        })
        .catch((err) => {
          if (err.message != "ERR_CANCELED") {
            this.cancel_chart_token.value = null;
          } else {
            this.cancel_chart_token.value = "CANCELED";
          }
        })
        .finally(() => {
          if (!this.cancel_chart_token.value) {
            this.loading_chart = false;
          }
        });
    },
    getChartScraper() {
      this.loading_chart_scraper = true;
      if (this.cancel_chart_scraper_token) {
        this.cancel_chart_scraper_token.cancel("ERR_CANCELED");
      }
      this.cancel_chart_scraper_token = axios.CancelToken.source();

      let params = {
        from_date: this.filter_data.from_date,
        to_date: this.filter_data.to_date,
      };
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api = process.env.VUE_APP_API_URL + "dashboard/charts-scraper?" + query;
      useJwt.axiosIns
        .get(api, { cancelToken: this.cancel_chart_scraper_token.token })
        .then((res) => {
          this.cancel_chart_scraper_token.value = null;
          if (res.status == 200) {
            this.chart_data_scraper.categories = res.data.categories;
            // series total 
            this.chart_data_scraper.series[0].name = res.data.series[0].name
            this.chart_data_scraper.series[0].data = res.data.series[0].value
            // series top 1-5
            for (let i = 1; i < res.data.series.length; i++) {
              this.chart_data_scraper.series[i].name = res.data.series[i].name
              this.chart_data_scraper.series[i].data = res.data.series[i].value
              this.chart_data_scraper.series[i].portal_name = res.data.series[i].portal_name
            }
          } else {
            this.chart_data_scraper = {
              categories: [],
              series: [],
            };
          }
        })
        .catch((err) => {
          if (err.message != "ERR_CANCELED") {
            this.cancel_chart_scraper_token.value = null;
          } else {
            this.cancel_chart_scraper_token.value = "CANCELED";
          }
        })
        .finally(() => {
          if (!this.cancel_chart_scraper_token.value) {
            this.loading_chart_scraper = false;
          }
        });
    },
    getChartStoryPoint() {
      this.loading_chart_sp = true;
      if (this.cancel_chart_sp_token) {
        this.cancel_chart_sp_token.cancel("ERR_CANCELED");
      }
      this.cancel_chart_sp_token = axios.CancelToken.source();

      let params = {
        from_date: this.filter_data.from_date,
        to_date: this.filter_data.to_date,
      };
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api = process.env.VUE_APP_API_URL + "dashboard/charts-story-point?" + query;
      useJwt.axiosIns
        .get(api, { cancelToken: this.cancel_chart_sp_token.token })
        .then((res) => {
          this.cancel_chart_sp_token.value = null;
          if (res.status == 200) {
            this.chart_data_sp.categories = res.data.categories;
            this.chart_data_sp.series = res.data.series.map(s => ({
              name: s.name,
              data: s.value
            }));
          } else {
            this.chart_data_sp = {
              categories: [],
              series: [],
            };
          }
        })
        .catch((err) => {
          if (err.message != "ERR_CANCELED") {
            this.cancel_chart_sp_token.value = null;
          } else {
            this.cancel_chart_sp_token.value = "CANCELED";
          }
        })
        .finally(() => {
          if (!this.cancel_chart_sp_token.value) {
            this.loading_chart_sp = false;
          }
        });
    },
    getStats() {
      this.loading_stats = true;
      if (this.cancel_stats_token) {
        this.cancel_stats_token.cancel("ERR_CANCELED");
      }
      this.cancel_stats_token = axios.CancelToken.source();

      let params = {
        from_date: this.filter_data.from_date,
        to_date: this.filter_data.to_date,
      };
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api = process.env.VUE_APP_API_URL + "dashboard/stats-log?" + query;
      useJwt.axiosIns
        .get(api, { cancelToken: this.cancel_stats_token.token })
        .then((res) => {
          this.cancel_stats_token.value = null;
          this.stats.error = res.data?.error_log || 0;
          this.stats.unavailable = res.data?.unavaile_log || 0;
          this.stats.redirected = res.data?.redirect_log || 0;
          this.stats.missing_class = res.data?.miss_class_log || 0;
          this.stats.fixed = res.data?.fixed_log || 0;
          this.stats.fixing_error = res.data?.fixing_error_log || 0;
        })
        .catch((err) => {
          if (err.message != "ERR_CANCELED") {
            this.cancel_stats_token.value = null;
          } else {
            this.cancel_stats_token.value = "CANCELED";
          }
        })
        .finally(() => {
          if (!this.cancel_stats_token.value) {
            this.loading_stats = false;
          }
        })
    },
  },
};
</script>
